// @flow
import { SEATING_OPTIONS } from "./reducer"

/**
 * Object that maps quick options from server response names to state names
 */
export const QUICK_OPTION_SERVER_MAPPER = Object.freeze({
  window: SEATING_OPTIONS.window,
  aisle: SEATING_OPTIONS.aisle,
  extra_leg_room: SEATING_OPTIONS.extraLegroom,
  sit_together: SEATING_OPTIONS.sitTogether,
})

/**
 * Object that maps quick options from state names to server response names
 */
export const QUICK_OPTION_STATE_MAPPER = Object.freeze({
  [SEATING_OPTIONS.window]: "window",
  [SEATING_OPTIONS.aisle]: "aisle",
  [SEATING_OPTIONS.extraLegroom]: "extra_leg_room",
  [SEATING_OPTIONS.sitTogether]: "sit_together",
})
